import React, { useRef, useEffect, useContext } from "react";

import GlobalContext from "contexts/context";
import DatabaseContext from "data/contextDatabase";
import WebsocketContext from "connectivity/contextWebsocket";
import LocationContext from "geospatial/contextLocation";

// import { useDerivedLocalKey, encrypt } from "hooks/encryptionHooks";
import { useLiveSendMessages } from "hooks/dbHooks";
import { useLiveSubscriptions, useLivePersonas } from "hooks/dbHooks";
import { randomString } from "hooks/helper";

/**
 *
 * @param {*} props
 * must include wss target url
 */

/**
 * TODO:
 * Define interface for API and callbacks
 */

const Wss = (props) => {
  const { globalState, globalDispatch } = useContext(GlobalContext);
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const { websocketState, websocketDispatch } = useContext(WebsocketContext);
  const { locationState } = useContext(LocationContext);
  // const derivedLocalKey = useDerivedLocalKey(
  //   [globalState.uid, globalState.password, databaseState.dbReady],
  //   []
  // );
  const liveSendMessages = useLiveSendMessages(databaseState.dbMaster);
  const livePersonas = useLivePersonas(
    databaseState.dbMaster,
    globalState.muid
  );
  const liveSubscriptions = useLiveSubscriptions(databaseState.dbMaster);
  const lastPull = useRef(null);
  const lastMuidPull = useRef(null);

  useEffect(() => {
    const sameLists = (a, b) => {
      console.log("handlePullTopics sameLists ", a, b);
      return (
        a?.length === b?.length &&
        a?.every(
          (e, i) =>
            e.mtopic === b[i].mtopic &&
            e.start_idx === b[i].start_idx &&
            e.stop_idx === b[i].stop_idx
        )
      );
    };
    const pullRange = (mtopic) => {
      return { mtopic: mtopic, start_idx: "-1", stop_idx: "3" };
    };
    let mtopics = liveSubscriptions.map((sub) => sub.mtopic);
    let topics = mtopics.map((mtopic) => pullRange(mtopic));
    if (topics && topics.length > 0 && !sameLists(lastPull.current, topics)) {
      lastPull.current = [...topics];
      let j = {
        type: "w.topic.hist",
        topics: topics,
        smid: "w.topic.hist", // randomString(8),
      };
      console.log("handlePullTopics ", j);
      false &&
        databaseState.dbMaster &&
        databaseDispatch({
          type: "UPSERT_REC",
          values: {
            jmessage: j,
            db: databaseState.dbMaster,
            collection: "send",
            table: "confirm_smid",
            rowid: j.smid,
            doc: j,
          },
        });
    }
    return () => {};
  }, [liveSubscriptions]);

  useEffect(() => {
    const pullMuidRange = () => {
      return [{ start_idx: "-1", stop_idx: "10" }];
    };
    if (globalState.muid && lastMuidPull.current !== globalState.muid) {
      lastMuidPull.current = globalState.muid;
      let j = {
        type: "w.mpersona.hist",
        ranges: pullMuidRange(),
        smid: "w.mpersona.hist", // randomString(8),
      };
      console.log("handlePullMuid ", j);
      false &&
        databaseState.dbMaster &&
        databaseDispatch({
          type: "UPSERT_REC",
          values: {
            jmessage: j,
            db: databaseState.dbMaster,
            collection: "send",
            table: "confirm_smid",
            rowid: j.smid,
            doc: j,
          },
        });
    }
    return () => {};
  }, [globalState.muid]);

  // fetch("https://reaches.me/api?type=servers", {
  //   mode: "cors",
  // }).then((result) => console.log(result));

  useEffect(() => {
    // Monitors liveSendMessages and sends any messages if type is in sendTypes
    console.log(
      "liveSendMessages: ",
      liveSendMessages,
      globalState.authenticated
    );
    const sendTypes = [
      "w.topic.hist",
      "w.mpersona.hist",
      "w.topic.message",
      "w.topic.subscribe.mtopic",
      "w.mpersona.message",
      "w.user.token.update",
      "w.user.token.set",
      "w.user.otp.request",
      "w.user.otp.response",
      "w.topic.destroy",
      "w.mpersona.stream.offer",
      "w.mpersona.stream.answer",
      "w.mpersona.stream.hang_up",
      "w.mpersona.stream.new_ice_candidate",
      // "w.user.subscription.getlist",
    ];
    // TODO: Should only subscribe if we are not yet subscribed to this topic
    if (websocketState.socket !== undefined && globalState.authenticated) {
      for (let i = 0, l = liveSendMessages.length; i < l; ++i) {
        if (
          liveSendMessages[i].type !== undefined &&
          sendTypes.indexOf(liveSendMessages[i].type) > -1
        ) {
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: liveSendMessages[i],
            },
          });
        }
      }
    }
    return () => {};
  }, [
    liveSendMessages,
    websocketDispatch,
    websocketState.socket,
    globalState.authenticated,
  ]);

  useEffect(() => {
    // when derivedLocalKey changes
    // updates the onMessage function
    // to include response, encryption and storage to database
    const respond = (jMessage) => {
      console.log("NOTIFY RESPOND", Date.now(), jMessage);
      let response;
      switch (jMessage.type) {
        case "w.transact.banks":
          response = {
            type: "w.obj.received",
            msgid: jMessage.msgid,
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
        case "w.transact.otp.result":
          response = {
            type: "w.obj.received",
            msgid: jMessage.msgid,
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
        case "w.topic.message":
          response = {
            type: "w.topic.message.received",
            msgid: jMessage.msgid,
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
        case "w.mpersona.message":
          response = {
            type: "w.mpersona.message.received",
            msgid: jMessage.msgid,
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
        case "w.topic.background.share":
          response = {
            type: "w.topic.message.received",
            msgid: jMessage.msgid,
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
        case "w.mpersona.background.share":
          response = {
            type: "w.topic.message.received",
            msgid: jMessage.msgid,
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
        default:
          response = {
            type: "w.topic.message.received",
            msgid: jMessage.msgid ? jMessage.msgid : "undefined",
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          response = {
            type: "w.obj.received",
            msgid: jMessage.msgid ? jMessage.msgid : "undefined",
            version: globalState.version,
          };
          websocketDispatch({
            type: "SEND",
            values: {
              jmessage: response,
            },
          });
          break;
      }
    };

    const sortJoin = (A, B, Delim) => {
      return A < B ? A + Delim + B : B + Delim + A;
    };

    const onMessage = (m) => {
      let message = m.data;

      if (m.currentTarget.readyState === 1) {
        console.log("NOTIFY message", Date.now(), message);
        switch (message) {
          case "Authenticated":
            sessionStorage.removeItem("tasklist");
            globalDispatch({
              type: "SET_AUTH",
              values: { authenticated: true },
            });
            // send "w.user.subscription.getlist"
            // let sj = {
            //   type: "w.user.subscription.getlist",
            //   version: globalState.version,
            //   smid: randomString(8),
            // };
            // databaseState.dbMaster &&
            //   databaseDispatch({
            //     type: "UPSERT_REC",
            //     values: {
            //       jmessage: sj,
            //       db: databaseState.dbMaster,
            //       collection: "send",
            //       table: "confirm_smid",
            //       rowid: sj.smid,
            //       doc: sj,
            //     },
            //   });
            break;
          default:
            try {
              const jMessage = JSON.parse(message);
              console.log("MESSAGE: ", jMessage);
              if (jMessage.smid) {
                jMessage.smid = "" + jMessage.smid;
              }
              switch (jMessage.type) {
                case "w.admin.parameter.setstring":
                  // Support for an acknowledgement to the server is still required
                  databaseDispatch({
                    type: "UPSERT_REC",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "parameters",
                      table: globalState.muid,
                      rowid: jMessage.parameter,
                      doc: {
                        muid: globalState.muid,
                        parameter: jMessage.parameter,
                        value: jMessage.value,
                      },
                    },
                  });
                  break;
                case "w.admin.parameter.delete":
                  // Support for an acknowledgement to the server is still required
                  databaseDispatch({
                    type: "DELETE_RECORD",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "parameters",
                      table: globalState.muid,
                      rowid: jMessage.parameter,
                      doc: jMessage,
                    },
                  });
                  break;
                case "w.user.otp.result":
                  let alertStr =
                    jMessage.result === "success"
                      ? "Your OTP for " +
                        jMessage.identifier +
                        " has been confirmed"
                      : "Your OTP for " + jMessage.identifier + " has failed";
                  alert(alertStr);
                  document.getElementById("otp_modal") &&
                    (document.getElementById("otp_modal").style.display =
                      "none");
                  respond(jMessage);
                  break;
                case "w.confirmed":
                  console.log("w.confirmed: ", jMessage);
                  databaseDispatch({
                    type: "DELETE_RECORD",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "send",
                      table: "confirm_smid",
                      rowid: jMessage.smid,
                      doc: jMessage,
                    },
                  });
                  break;
                case "w.topic.message":
                  console.log("w.topic.message: ", jMessage);
                  respond(jMessage);
                  // encrypt and store, using database from state
                  // encrypt(derivedLocalKey, message).then((enc_message) => {
                  //   console.log("UILogin enc_message", enc_message);
                  databaseDispatch({
                    type: "UPSERT_REC",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "messages",
                      table: jMessage.mtopic,
                      rowid: jMessage.smid,
                      doc: jMessage,
                      notify: globalState.displaying_topic === undefined,
                    },
                  });
                  // });
                  break;
                case "w.mpersona.message":
                  console.log(
                    "w.mpersona.message livePersonas: ",
                    livePersonas.map((p) => p?.mpersona)
                  );
                  // if (jMessage.yourmpersona livePersonas.map((p) => p.mpersona )
                  if (
                    !jMessage?.yourmpersona &&
                    jMessage.muid === globalState.muid
                  ) {
                    jMessage.yourmpersona = jMessage.mpersona;
                    jMessage.yourpersona = jMessage.persona;
                  }
                  respond(jMessage);
                  if (
                    !livePersonas
                      .map((p) => p?.mpersona)
                      .includes(jMessage?.yourmpersona)
                  ) {
                    console.log("w.mpersona.message break: ", jMessage);
                    break;
                  }
                  // encrypt and store, using database from state
                  // encrypt(derivedLocalKey, message).then((enc_message) => {
                  //   console.log("UILogin enc_message", enc_message);
                  let mdialog =
                    jMessage.visibility === "PRIVATE_MONOLOGUE"
                      ? jMessage.mpersona
                      : sortJoin(jMessage.mpersona, jMessage.peer, "_") +
                        (jMessage.tag !== undefined ? "/" + jMessage.tag : "");
                  console.log("Recieved dialog: ", mdialog);
                  // databaseDispatch({
                  //   type: "DELETE_SMID",
                  //   values: {
                  //     db: databaseState.dbMaster,
                  //     startkey: "54messages4" + mdialog,
                  //     endkey: "54messages4" + mdialog + "",
                  //     jMessage: jMessage,
                  //   },
                  // });
                  databaseDispatch({
                    type: "UPSERT_REC",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "messages",
                      table: mdialog,
                      rowid: jMessage.smid,
                      doc: jMessage,
                      notify: globalState.displaying_topic === undefined,
                    },
                  });
                  let docDialog = {
                    mdialog: mdialog,
                    dialog:
                      jMessage.yourmpersona === jMessage.peer
                        ? jMessage.persona
                        : jMessage.peerpersona,
                    peer:
                      jMessage.yourmpersona === jMessage.peer
                        ? jMessage.mpersona
                        : jMessage.peer,
                    peerpersona:
                      jMessage.yourmpersona === jMessage.peer
                        ? jMessage.persona
                        : jMessage.peerpersona,
                    persona: jMessage.yourpersona,
                    mpersona: jMessage.yourmpersona,
                    got_voice:
                      jMessage.visibility === "PRIVATE_MONOLOGUE"
                        ? false
                        : true,
                    visibility: jMessage.visibility,
                  };
                  if (jMessage.tag !== undefined) {
                    docDialog.tag = jMessage.tag;
                    docDialog.topic_display_name =
                      jMessage.topic_display_name ??
                      docDialog.dialog + "_" + jMessage.tag;
                  }
                  databaseDispatch({
                    type: "UPSERT_REC",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "dialog",
                      table: globalState.muid,
                      rowid: mdialog,
                      doc: docDialog,
                    },
                  });
                  // });
                  break;
                case "w.mpersona.stream.offer":
                  console.log("receive stream message ", jMessage);
                  respond(jMessage);
                  databaseDispatch({
                    // type: "UPSERT_REC",
                    type: "ADD_RECORD",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "messages",
                      table: "stream",
                      rowid: jMessage.smid,
                      doc: jMessage,
                    },
                  });
                  break;
                case "w.mpersona.stream.answer":
                  console.log("receive stream message ", jMessage);
                  respond(jMessage);
                  databaseDispatch({
                    // type: "UPSERT_REC",
                    type: "ADD_RECORD",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "messages",
                      table: "stream",
                      rowid: jMessage.smid,
                      doc: jMessage,
                    },
                  });
                  break;
                case "w.mpersona.stream.hang_up":
                  console.log("receive stream message ", jMessage);
                  respond(jMessage);
                  databaseDispatch({
                    // type: "UPSERT_REC",
                    type: "ADD_RECORD",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "messages",
                      table: "stream",
                      rowid: jMessage.smid,
                      doc: jMessage,
                    },
                  });
                  break;
                case "w.mpersona.stream.new_ice_candidate":
                  console.log("receive stream message ", jMessage);
                  respond(jMessage);
                  databaseDispatch({
                    // type: "UPSERT_REC",
                    type: "ADD_RECORD",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "messages",
                      table: "stream",
                      rowid: jMessage.smid,
                      doc: jMessage,
                    },
                  });
                  break;
                case "w.topic.background.share":
                  console.log("w.topic.background.share: ", jMessage);
                  respond(jMessage);
                  break;
                case "w.mpersona.background.share":
                  console.log("w.topic.background.share: ", jMessage);
                  respond(jMessage);
                  break;
                case "w.transact.banks":
                  console.log("w.transact.banks: ", jMessage);
                  respond(jMessage);
                  break;
                case "w.user.subscription.list":
                  // no response needed
                  console.log("w.user.subscription.list: ", jMessage);
                  globalDispatch({
                    type: "SET_MUID",
                    values: { muid: jMessage.muid },
                  });
                  databaseDispatch({
                    type: "UPSERT_REC",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "account_data",
                      table: "user_info",
                      rowid: "muid",
                      doc: { uid: globalState.uid, muid: jMessage.muid },
                    },
                  });
                  databaseDispatch({
                    type: "UPSERT_REC",
                    values: {
                      db: databaseState.dbMaster,
                      collection: "account_data",
                      table: "subscriptions",
                      rowid: "muid", // jMessage.muid,
                      doc: jMessage,
                    },
                  });
                  break;
                case "...":
                  console.log("...: ", jMessage);
                  break;
                default:
                  console.log("ALERT !!! Unhandled message: ", jMessage);
                  respond(jMessage);
              }
            } catch (err) {
              console.log("unhandled message: ", message);
            }
        }
      }
    };
    // derivedLocalKey === null ||
    globalState.uid === null ||
    globalState.uid === undefined ||
    databaseState.dbMaster === null ||
    databaseState.dbMaster?.name !== globalState.uid ||
    databaseState.dbReady !== true
      ? console.log("WebSocket message not yet ready")
      : websocketDispatch({
          type: "SET_ONMESSAGE",
          values: {
            onmessage: onMessage,
          },
        });
    return () => {};
  }, [
    databaseState.dbMaster,
    websocketDispatch,
    databaseDispatch,
    globalDispatch,
    globalState.uid,
    globalState.authenticated,
    globalState.password,
    globalState.muid,
    livePersonas,
    databaseState.dbReady,
    globalState.version,
    globalState.displaying_topic,
  ]);

  useEffect(() => {
    const onOpen = () => {
      globalDispatch({
        type: "SET_AUTH",
        values: { authenticated: false },
      });
      // send a message
      var j = {
        type: "w.user.authenticate",
        uid: globalState.uid,
        pwd: globalState.password,
        cid: globalState.cid,
        imei: "",
        lat: "" + locationState.latitude,
        lon: "" + locationState.longitude,
        version: globalState.version,
      };
      try {
        let task_list = JSON.parse(sessionStorage.getItem("tasklist"));
        if (task_list !== null && task_list !== undefined) {
          j.task_list = task_list;
        }
      } catch {}
      console.log("auth: ", j);
      websocketDispatch({
        type: "SEND",
        values: {
          jmessage: j,
        },
      });
    };

    const onClose = () => {
      console.log("WebSocket closed: ");
      // globalDispatch({
      //   type: "SET_AUTH",
      //   values: { authenticated: false },
      // });
      // !globalState.connected
      //   ? console.log("Not connected")
      //   :
      websocketDispatch({
        type: "OPEN",
        values: {
          url: props.url,
          onopen: onOpen,
          onclose: onClose,
          onerror: onError,
          onmessage: onMessage,
        },
      });
    };

    const onError = (e) => {
      console.log("WebSocket error: ", e);
    };

    const onMessage = (m) => {
      console.log("WebSocket message: ", m);
      if (m.data === "Authenticated") {
        sessionStorage.removeItem("tasklist");
        globalDispatch({
          type: "SET_AUTH",
          values: { authenticated: true },
        });
      }
    };

    websocketDispatch({
      type: "CLOSE",
    });

    console.log(
      "Wss db ready?: ",
      globalState.password,
      globalState.uid,
      globalState.cid,
      databaseState.dbReady,
      props.url,
      databaseState.dbMaster
    );
    globalState.password === undefined ||
      globalState.uid === null ||
      globalState.uid === undefined ||
      globalState.cid === undefined ||
      databaseState.dbMaster?.name !== globalState.uid ||
      databaseState.dbReady !== true ||
      websocketDispatch({
        type: "OPEN",
        values: {
          url: props.url,
          onopen: onOpen,
          onclose: onClose,
          onerror: onError,
          onmessage: onMessage,
        },
      });

    return () => {};
  }, [
    globalDispatch,
    globalState.password,
    globalState.uid,
    globalState.cid,
    databaseState.dbMaster,
    props.url,
    websocketDispatch,
    databaseState.dbReady,
    globalState.version,
    locationState.latitude,
    locationState.longitude,
  ]);

  let content = <div></div>;
  return content;
};

export default React.memo(Wss, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
